import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useCookies } from '@techstyle/redux-core';
export var ReferringPageContext = /*#__PURE__*/React.createContext();
export default function ReferringPageProvider(_ref) {
  var children = _ref.children,
      cookieName = _ref.cookieName;

  var _useCookies = useCookies([cookieName]),
      _useCookies2 = _slicedToArray(_useCookies, 3),
      setCookie = _useCookies2[1],
      removeCookie = _useCookies2[2];

  var setReferringPage = useCallback(function (gaLabel) {
    if (gaLabel) {
      setCookie(cookieName, gaLabel.trim());
    } else {
      removeCookie(cookieName);
    }
  }, [cookieName, removeCookie, setCookie]);
  var value = {
    cookieName: cookieName,
    setReferringPage: setReferringPage
  };
  return /*#__PURE__*/React.createElement(ReferringPageContext.Provider, {
    value: value
  }, children);
}
ReferringPageProvider.propTypes = {
  children: PropTypes.node,
  cookieName: PropTypes.string
};
ReferringPageProvider.Context = ReferringPageContext;